var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { addPaymentInfo } from '../pages/payment-info/components/atoms';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import useCustomToast from './use-custom-toast';
import Styles from '../pages/payment-info/payment-info-styles.scss';
import { Auth } from 'aws-amplify';
import { isSmallOrFreePlan } from '../constants/plans';
import usePartner from './use-partner';
const isLocalhost = () => {
    return window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1');
};
export const usePaymentInfo = ({ getInfo, validation, loadStates, getStripePage, manageUsers }) => {
    const [searchParams] = useSearchParams();
    // Query params
    const idClient = parseInt(searchParams.get('idClient'));
    const plan = searchParams.get('plan');
    const isSmallOrFreePlanVar = isSmallOrFreePlan(plan);
    // Hooks
    const [state, setState] = useRecoilState(addPaymentInfo);
    const { search } = useLocation();
    const nativeNavigate = useNavigate();
    const resetPaymentInfo = useResetRecoilState(addPaymentInfo);
    const [paymentData, setPaymentData] = useState(null);
    const [header, setHeader] = useState('');
    const [totalCost, setTotalCost] = useState(0);
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [useFreeTrial, setUseFreeTrial] = useState(false);
    const [changedPlan, setChangedPlan] = useState({
        upgraded: false,
        downgraded: false
    });
    const upgradeFlow = parseInt(searchParams.get('upgradeFlow'));
    const isUpgradeFlow = upgradeFlow === 1;
    const expired = parseInt(searchParams.get('expired'));
    const customDashboard = expired === 1 ? 'expired' : 'school-dashboard';
    const { rootPath } = usePartner({});
    // const [currentPlan, setCurrentPlan] = useState(null);
    const [checkedTC, setCheckedTC] = useState(false);
    const [Continue, setContinue] = useState(false);
    const { toastContainer, showCustomError, showCustomWarning } = useCustomToast({
        containerId: 'allVideos',
        toastClassName: Styles.toastClassName
    });
    const navigate = (url) => nativeNavigate(`${url}${search}`);
    // const { address, addressState, addressZip, addressLine2 } = accountInfo;
    const cancelUrl = isLocalhost() ? 'https://app.dev.kidvestors.co/' : window.location.href;
    const getCurrentUser = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            const userInfo = yield Auth.currentUserInfo();
            if (userInfo && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.username)) {
                const currentUser = yield manageUsers.findOneWithClient(userInfo.username);
                if (currentUser && currentUser.length > 0) {
                    setCurrentUser(currentUser[0]);
                }
                setLoading(false);
                return '';
            }
            else {
                showCustomWarning('Oops', 'Restoring session...');
                setTimeout(() => {
                    navigate(`/resume-school-registration/${idClient}`);
                }, 2000);
            }
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
            return '';
        }
    });
    useEffect(() => {
        getCurrentUser();
    }, []);
    const getInfoPay = (idClient, plan) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            setLoading(true);
            const infopay = yield getInfo.getPaymentInfo({
                idClient: idClient,
                plan
            });
            if (infopay === null || infopay === void 0 ? void 0 : infopay.plan) {
                if (plan === null || plan === void 0 ? void 0 : plan.includes('free-trial')) {
                    setHeader('Discovery Pass - Up to 49 Students');
                }
                else {
                    setHeader(infopay.plan);
                }
            }
            setChangedPlan({
                upgraded: infopay === null || infopay === void 0 ? void 0 : infopay.upgraded,
                downgraded: infopay === null || infopay === void 0 ? void 0 : infopay.downgraded
            });
            if (((_a = infopay === null || infopay === void 0 ? void 0 : infopay.items) === null || _a === void 0 ? void 0 : _a.length) === 0 || !(infopay === null || infopay === void 0 ? void 0 : infopay.items)) {
                showCustomError('Error', 'Error getting payment info');
                setPaymentData(null);
            }
            else {
                const amountFormated = infopay.items.map(item => {
                    return Object.assign(Object.assign({}, item), { priceStripe: Object.assign(Object.assign({}, item.priceStripe), { unit_amount: item.priceStripe.unit_amount / 100 }) });
                });
                setState(Object.assign(Object.assign({}, state), { suscriptionId: infopay === null || infopay === void 0 ? void 0 : infopay.plan }));
                setPaymentData(Object.assign(Object.assign({}, infopay), { items: amountFormated }));
                let totalAmount = 0;
                (_b = infopay === null || infopay === void 0 ? void 0 : infopay.items) === null || _b === void 0 ? void 0 : _b.forEach(line => {
                    totalAmount += (line.priceStripe.unit_amount * line.quantity) / 100;
                });
                setTotalCost(totalAmount);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    });
    const setCostPerStudent = (cost, students) => {
        if (students > 0) {
            return `${(cost / students).toFixed(2)}`;
        }
        else {
            return '';
        }
    };
    const setUseCheckedTC = (value) => {
        setCheckedTC(value);
    };
    const handleContinue = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        try {
            setContinue(true);
            if (checkedTC) {
                if (paymentData && paymentData.items) {
                    const dataToSend = {
                        items: (_c = paymentData === null || paymentData === void 0 ? void 0 : paymentData.items) === null || _c === void 0 ? void 0 : _c.map(line => ({
                            priceId: line === null || line === void 0 ? void 0 : line.priceId,
                            quantity: line === null || line === void 0 ? void 0 : line.quantity
                        })),
                        cancelUrl,
                        flagClientAsClearSubscriptionFreeTrial: isUpgradeFlow
                    };
                    if (useFreeTrial) {
                        dataToSend.freeTrial = true;
                    }
                    setLoading(true);
                    const res = yield getStripePage.getPage(dataToSend);
                    setLoading(false);
                    if (res && res.url) {
                        window.location.href = res.url;
                    }
                }
            }
        }
        catch (error) {
            console.error(error);
            showCustomError('Error', 'An error has occurred, please try again later');
        }
    });
    const handleBack = () => {
        if (isUpgradeFlow) {
            navigate(`${rootPath}${customDashboard}/school-upgrade-flow/add-students`);
        }
        else {
            navigate(`${rootPath}add-students`);
        }
    };
    const validateIfMandatory = (field, value) => {
        return 'name' in field && typeof field[value] === 'string';
    };
    // USEEFFECTS
    useEffect(() => {
        if (isNaN(idClient) || !plan) {
            nativeNavigate('/signup');
        }
    }, [idClient, plan]);
    useEffect(() => {
        if (idClient && plan) {
            getInfoPay(idClient, plan);
        }
    }, [idClient, plan]);
    useEffect(() => resetPaymentInfo(), []);
    useEffect(() => {
        if (plan) {
            setUseFreeTrial(plan === null || plan === void 0 ? void 0 : plan.includes('free-trial'));
        }
    }, [plan]);
    return {
        state,
        setState,
        navigate,
        validateIfMandatory,
        handleContinue,
        handleBack,
        getInfoPay,
        resetPaymentInfo,
        nativeNavigate,
        paymentData,
        header,
        totalCost,
        setCostPerStudent,
        loading,
        toastContainer,
        useFreeTrial,
        setUseFreeTrial,
        // currentPlan,
        currentUser,
        setUseCheckedTC,
        checkedTC,
        Continue,
        changedPlan,
        isSmallOrFreePlanVar,
        isUpgradeFlow
    };
};
